<template>
  <v-container>
    <okil-file-sender
      v-if="action === 'attach-files'"
      :busy="busy"
      :params="params.params"
      :extra="params.extra"
      @send="dispatch"
    />

    <template v-else-if="action === 'barcode-scanner'">
      <okil-barcode-scanner
        v-if="!busy"
        :acceptor-name="barcodeAcceptorName"
        :result="scanner.result"
        @onLoaded="onScannerLoaded"
        @onDecode="dispatch"
        @close="close"
      />
    </template>

    <core-loading-dialog
      v-if="dialog.open"
      :error-title="dialog.title"
      :error-message="dialog.message"
      @close="closeDialog"
    />

    <core-confirm-dialog
      v-if="(confirmDialog.initiator === $options.name) && (confirmDialog.question !== undefined)"
      :title="confirmDialog.title"
      :fullscreen="false"
      :question="confirmDialog.question"
      :buttons="confirmDialog.buttons"
      @confirm="closeConfirmDialog"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import {
  beepOk,
  beepError,
  copyObject,
  isEmpty,
  openConfirmDialog
} from '../utils/functions'
export default {
  name: 'ExtActions',

  data: () => ({
    uuid: null,
    busy: false,
    params: undefined,
    dialog: {
      open: false,
      title: '',
      message: ''
    },
    scanner: {
      result: ''
    },
    defaultErrorMessage: 'Непредвиденная ошибка при отправке данных. Обратитесь в техподдержку!'
  }),

  computed: {
    ...mapState({
      confirmDialog: state => state.confirmDialog
    }),

    action () {
      return (isEmpty(this.params) || isEmpty(this.params.action)) ? null : this.params.action
    },

    barcodeAcceptorName () {
      if (isEmpty(this.params)) return ''
      if (isEmpty(this.params.extra)) return ''
      if (isEmpty(this.params.extra.talk)) return ''
      if (isEmpty(this.params.extra.talk.subject)) return ''
      return this.params.extra.talk.subject
    }
  },

  mounted () {
    this.logout(false)
    const urlParams = this.parseUrl()
    if (isEmpty(urlParams)) {
      this.logout()
    } else {
      if (isEmpty(urlParams.uuid)) {
        this.logout()
      } else {
        this.uuid = urlParams.uuid
        this.$store.dispatch('extActions/REQUEST', { uuid: this.uuid })
          .then(resp => {
            if (resp.data.error === 0) {
              const { action, payload, extra, token } = resp.data.action

              this.$store.dispatch('auth/CHECK_TOKEN_REQUEST', token)
                .then(() => {
                  console.log('Авторизован по токену ext-action\'а')
                  this.params = {
                    action,
                    payload: JSON.parse(payload),
                    extra: isEmpty(extra) ? {} : JSON.parse(extra)
                  }
                })
                .catch(() => {
                  console.log('Токен ext-action\'а отвергнут сервером')
                  this.logout()
                })
            } else {
              console.log('Попытка запроса устаревшего ext-action\'а')
              this.logout()
            }
          })
      }
    }
  },

  methods: {
    parseUrl () {
      let parts = window.location.href.split('?')
      if (parts.length === 2) {
        let vars = parts[1].split('&')
        let params = {}
        let tmp = ''
        vars.forEach(v => {
          tmp = v.split('=')
          if (tmp.length === 2) {
            params[tmp[0]] = decodeURIComponent(tmp[1])
          }
        })
        return params
      }
      return null
    },

    logout (restart = true) {
      this.$store.commit('auth/AUTH_LOGOUT', restart)
    },

    closeDialog () {
      this.dialog.open = false
      location.reload()
    },

    closeConfirmDialog (answer) {
      this.$store.commit('SET_CONFIRM_DIALOG', { answer, question: undefined }, { root: true })
    },

    dispatch (...args) {
      switch (this.action) {
        case 'attach-files':
          this.sendFiles(args[0])
          break

        case 'barcode-scanner':
          this.sendScanResult(args[0])
          break
      }
    },

    onScannerLoaded () {
      this.scanner.result = 'Поиск...'
    },

    close () {
      this.$store.dispatch('extActions/DELETE', { uuid: this.uuid })
        .finally(() => {
          this.$router.push('/end-of-session')
        })
    },

    error (message, title, buttons) {
      title = title !== undefined ? title : 'Ошибка'
      buttons = (buttons !== undefined)
        ? buttons
        : [
            {
              label: 'Продолжить',
              color: 'success',
              value: 1
            },
            {
              label: 'Закончить',
              color: 'warning',
              value: 0
            }
          ]
      return openConfirmDialog(this.$options.name, message, title, buttons)
    },

    ifScanAgain (message, title) {
      const buttons = [
        {
          label: 'Сканировать',
          color: 'info',
          icon: 'mdi-barcode-scan',
          value: 1
        },
        {
          label: 'Закончить',
          color: 'warning',
          icon: 'mdi-cancel',
          value: 0
        }
      ]
      return openConfirmDialog(this.$options.name, message, title, buttons)
    },

    sendScanResult (result) {
      if (this.busy) { return }

      this.busy = true
      const matches = Array.from(result.matchAll(/(.+):\/\/(.+)/g))

      // Был отсканирован QR-код со ссылкой
      if (matches.length > 0) {
        beepOk()
        window.location.href = result
      } else {
        this.scanner.result = result + '...'
        const params = copyObject(this.params)
        params.payload.ScanData = { ШтрихКод: result }

        this.$store.dispatch('extActions/ACTION', params)
          .then(resp => {
            if (resp.data.error === 0) {
              beepOk()
              this.scanner.result = resp.data.result
              this.ifScanAgain(resp.data.result.info + '<br><br> Сканировать снова?', 'Результат')
                .then(answer => {
                  if (answer === 1) {
                    this.resetScanner()
                  } else {
                    this.close()
                  }
                })
            } else {
              beepError()
              let msg = (resp.data.msg !== undefined) ? resp.data.msg : this.defaultErrorMessage
              this.error(msg + '<br><br> Сканировать снова?', 'Результат', [
                {
                  label: 'Сканировать',
                  color: 'info',
                  icon: 'mdi-barcode-scan',
                  value: 1
                },
                {
                  label: 'Закончить',
                  color: 'warning',
                  icon: 'mdi-cancel',
                  value: 0
                }
              ])
                .then(answer => {
                  if (answer === 1) {
                    this.resetScanner()
                  } else {
                    this.close()
                  }
                })
            }
          })
          .catch(err => {
            beepError()
            this.error(this.defaultErrorMessage)
              .then(answer => {
                if (answer === 1) {
                  this.resetScanner()
                } else {
                  this.close()
                }
              })
            console.log(err)
          })
      }
    },

    resetScanner () {
      this.scanner.result = ''
      this.busy = false
    },

    sendFiles (payload) {
      const { files } = payload
      const params = copyObject(this.params)
      params.files = files

      this.busy = true
      this.$store.dispatch('extActions/ACTION', params)
        .then(resp => {
          if (resp.data.error === 0) {
            beepOk()
            this.error('Загружено файлов: ' + resp.data.count, 'Загрузка файлов',
              [
                {
                  label: 'Закончить',
                  color: 'warning',
                  value: 0
                },
                {
                  label: 'Продолжить',
                  color: 'success',
                  value: 1
                }
              ]
            )
            .then(answer => {
              if (answer === 1) {
                window.location.reload()
              } else {
                this.close()
              }
            })
          } else {
            beepError()
            const msg = (resp.data.msg !== undefined) ? resp.data.msg : 'Ошибка при отправке файлов. Обратитесь в техподдержку!'
            this.error(msg, 'Ошибка',
              [
                {
                  label: 'Закрыть',
                  color: 'warning',
                  value: 0
                }
              ]
            )
            .then(() => {
              this.close()
            })
          }
        })
        .catch(err => {
          beepError()
          console.log(err)
          const msg = 'Непредвиденная ошибка при отправке файлов. Обратитесь в техподдержку!'
          this.error(msg, 'Ошибка',
            [
              {
                label: 'Закрыть',
                color: 'warning',
                value: 0
              }
            ]
          )
          .then(() => {
            this.close()
          })
        })
        .finally(() => { this.busy = false })
    }
  }
}
</script>
